import getApi from '../../api/apisauceConfig'
import { SessionHistoryEvent } from '../../model/UserSession'

export interface GetUserSessionsHistoryParams {
  /** Index du premier élément (pagination façon Keycloak). */
  first: number
  /** Nombre maximum d'éléments retournés. */
  max: number
}

export const getUserSessionsHistory = (
  { first, max }: GetUserSessionsHistoryParams,
  signal?: AbortSignal,
) =>
  getApi().get<SessionHistoryEvent[]>(
    '/users/me/sessions/history',
    {
      first,
      max,
    },
    { signal },
  )
